.carousel {
  position: relative;
  min-width: 0;
  min-height: calc(100svh - 3.75rem);
  overflow: hidden;
  background: var(--color-surface);
}

.slides,
.slide {
  position: absolute;
  inset: 0;
}

.slide {
  visibility: hidden;
  opacity: 0;
  transition:
    opacity 600ms ease,
    visibility 600ms ease;
}

.active {
  visibility: visible;
  opacity: 1;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgb(2 7 4 / 88%) 0%, rgb(2 7 4 / 52%) 44%, transparent 76%),
    linear-gradient(0deg, rgb(2 7 4 / 38%), transparent 40%);
}

.overlaySoft {
  background: linear-gradient(
    0deg,
    rgb(2 7 4 / 74%) 0%,
    rgb(2 7 4 / 34%) 26%,
    transparent 50%
  );
}

.content {
  position: absolute;
  top: 50%;
  left: clamp(1.5rem, 5vw, 4rem);
  width: min(28rem, calc(100% - 3rem));
  transform: translateY(-50%);
}

.contentBottom {
  top: auto;
  bottom: clamp(3.25rem, 7vh, 5rem);
  width: min(34rem, calc(100% - 3rem));
  transform: none;
}

.contentBottom .eyebrow {
  margin-bottom: 0.45rem;
  font-size: 0.68rem;
}

.eyebrow {
  margin: 0 0 0.65rem;
  color: #b9dc5a;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.content h1 {
  margin: 0;
  font-size: clamp(2rem, 4.5vw, 3.7rem);
  line-height: 1.04;
  letter-spacing: -0.04em;
  overflow-wrap: anywhere;
  text-shadow: 0 0.6rem 1.8rem rgb(0 0 0 / 65%);
}

.contentBottom h1 {
  font-size: clamp(1.45rem, 2.4vw, 2.15rem);
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.content > p:not(.eyebrow) {
  max-width: 25rem;
  margin: 1rem 0 0;
  color: #c7d1ca;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.indicators {
  position: absolute;
  bottom: 1.35rem;
  left: 50%;
  display: flex;
  gap: 0.45rem;
  transform: translateX(-50%);
}

.indicators button {
  width: 0.5rem;
  height: 0.5rem;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: rgb(255 255 255 / 45%);
  cursor: pointer;
  transition:
    width 180ms ease,
    background-color 180ms ease;
}

.indicators .current {
  width: 1.5rem;
  background: var(--color-primary);
}

@media (prefers-reduced-motion: reduce) {
  .slide,
  .indicators button {
    transition: none;
  }
}

@media (max-width: 600px) {
  .carousel {
    min-height: 28rem;
  }

  .overlay {
    background: linear-gradient(90deg, rgb(2 7 4 / 88%), rgb(2 7 4 / 42%));
  }

  .overlaySoft {
    background: linear-gradient(
      0deg,
      rgb(2 7 4 / 80%) 0%,
      rgb(2 7 4 / 38%) 32%,
      transparent 58%
    );
  }

  .content {
    top: 46%;
    left: 1.25rem;
    width: calc(100% - 2.5rem);
  }

  .contentBottom {
    top: auto;
    bottom: 3rem;
    width: calc(100% - 2.5rem);
  }

  .content h1 {
    font-size: clamp(1.9rem, 10vw, 2.7rem);
  }

  .contentBottom h1 {
    font-size: clamp(1.35rem, 5.5vw, 1.75rem);
  }

  .content > p:not(.eyebrow) {
    font-size: 0.9rem;
  }

  .indicators {
    bottom: 1.1rem;
    left: 1.25rem;
    transform: none;
  }
}
